export default "__VITE_ASSET__43ab8df1__"